/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Barcode_ButtonInputs */

const vi_mobile_scan_barcode_button = /** @type {(inputs: Mobile_Scan_Barcode_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét barcode`)
};

/**

* @param {Mobile_Scan_Barcode_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_barcode_button = /** @type {((inputs?: Mobile_Scan_Barcode_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Barcode_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_scan_barcode_button(inputs)
});